import { createSelector } from 'reselect'

const SORT_AWARE_SYSTEM_TYPES = ['meetingStart', 'meetingEnd'];

const getProjectDiscussions = (discussions, projectId) => discussions
    .filter(discussion => discussion.project === projectId && !discussion.archived)
    .sort((d1, d2) => {
        if (d1.is_general) return -3;
        if (d2.is_general) return 3;
        if (d1.archived) return 2;
        if (d2.archived) return -2;

        return d1.name > d2.name ? 1 : -1;
    });
export const makeGetProjectDiscussions = () => createSelector(getProjectDiscussions, discussions => discussions);

const getDiscussion = (discussions, id) => discussions.find(discussion => discussion.id === id);
export const makeGetDiscussion = () => createSelector(getDiscussion, discussion => discussion);

const getGeneralDiscussion = (discussions, projectId) => discussions.find(discussion => discussion.project === projectId && discussion.is_general);
export const makeGetGeneralDiscussion = () => createSelector(getGeneralDiscussion, discussion => discussion);

const getSelfDiscussion = discussions => discussions.find(discussion => discussion.is_self);
export const makeGetSelfDiscussion = () => createSelector(getSelfDiscussion, discussion => discussion);

const getTeamDiscussions = discussions => discussions.filter(discussion => !discussion.error && !discussion.project && !discussion.is_self);
export const makeGetTeamDiscussions = () => createSelector(getTeamDiscussions, discussions => discussions);

const getSortedTeamDiscussions = (discussions, messages, notifications, maxCount = Number.POSITIVE_INFINITY) => discussions
    .filter(discussion =>
        !discussion.error &&
        !discussion.project &&
        !discussion.is_self
    )
    .sort((d1, d2) => {
        const d1Notification = notifications.find(notification => notification.association?.id === d1.id);
        const d2Notification = notifications.find(notification => notification.association?.id === d2.id);
        const d1Message = messages.find(message => message.chat === d1.id && (!message.subtype || SORT_AWARE_SYSTEM_TYPES.includes(message.subtype)));
        const d2Message = messages.find(message => message.chat === d2.id && (!message.subtype || SORT_AWARE_SYSTEM_TYPES.includes(message.subtype)));
        const d1MessssageDate = d1Message ? new Date(d1Message.created_at).getTime() : 0;
        const d2MessssageDate = d2Message ? new Date(d2Message.created_at).getTime() : 0;
        const d1NotificationDate = d1Notification ? new Date(d1Notification.created_at).getTime() : 0;
        const d2NotificationDate = d2Notification ? new Date(d2Notification.created_at).getTime() : 0;

        const d1Date = Math.max(d1NotificationDate, d1MessssageDate, new Date(d1.last_message_at || d1.created_at).getTime());
        const d2Date = Math.max(d2NotificationDate, d2MessssageDate, new Date(d2.last_message_at || d2.created_at).getTime());
        return d2Date - d1Date;
    })
    .splice(0, maxCount);
export const makeGetSortedTeamDiscussions = () => createSelector(getSortedTeamDiscussions, discussions => discussions);

const getSortedTeamDiscussionsWithoutRemoved = (discussions, messages, notifications, maxCount = Number.POSITIVE_INFINITY, users) => getSortedTeamDiscussions(discussions, messages, notifications, maxCount)
    .filter(discussion =>
        discussion.type !== 'direct' ||
        !discussion.members ||
        !discussion.members.some(user => users.find(u => u.id === user.id && u.removed))
    );
export const makeGetSortedTeamDiscussionsWithoutRemoved = () => createSelector(getSortedTeamDiscussionsWithoutRemoved, discussions => discussions);

const getDiscussionByMembers = (discussions, userIds) => {
    const userIdsString = [...new Set(userIds)].sort().toString();

    return discussions.find(discussion => discussion.members.map(user => user.id).sort().toString() === userIdsString);
};
export const makeGetDiscussionByMembers = () => createSelector(getDiscussionByMembers, discussion => discussion);

const getDirectChatByMembers = (discussions, userIds) => {
    const userIdsString = [...new Set(userIds)].sort().toString();

    return discussions.find(discussion => discussion.type === 'direct' && discussion.members.map(user => user.id).sort().toString() === userIdsString);
};
export const makeGetDirectChatByMembers = () => createSelector(getDirectChatByMembers, discussion => discussion);
